module.exports = __webpack_public_path__ + "static/media/currency-euro-dollar-exchange.4955532b.svg";